import api from "./axios-client.js";

export const getProfile = async() => {
    try{
        const response = await api.get('/profile');
        return response.data;
    }catch(err){
        return {error:err};
    }

}
